import React from 'react'
import { Form, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import RichTextEditor from '../../RichTextEditor'
import Metadata from '../Metadata'

const details = ({obj, language, onChange, status}) => {
  const addLinkButton = !status.isNew
    ? <Link to={`/blog/authors/${obj.id}/links/${obj.translations[language.code].id}`} floated='right' className='ui button olive'><Icon name="chain" /> Liens additionnels</Link>
    : ''

  return (
    <div>
      <Form.Field>
        <label>Description</label>
        <RichTextEditor id='description' value={obj.translations[language.code].description} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Metadata obj={obj} language={language} onChange={onChange} />
      <br />
      {addLinkButton}
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/author/details.js